module.exports = __webpack_public_path__ + "media/components/weather-icon/static/daycloud@3-37a7317119bd23e81d24295d1455af9c.png";